import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import TextBox from '../../../../../../shared/components/form/TextBox';
import renderCheckBoxField from '../../../../../../shared/components/form/CheckBox';
import renderSelectField from '../../../../../../shared/components/form/Select';
// import renderDatePickerField from '../../../../../../shared/components/form/DatePicker';
import setPropsAsInitialValues from '../../../../../../helpers/setPropsAsInitialValues';
import validateForm from './validate';

// Componente simple para mostrar el error de un campo
const renderErrorField = ({ meta: { touched, error } }) => (
  touched
    && error
    ? (
      <span
        className="form__form-group-error"
        style={{ marginBottom: '5px' }}
      >
        {error}
      </span>
    )
    : null
);
renderErrorField.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
};

class ContentRecordForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onChanges: PropTypes.func.isRequired,
    onTextChanges: PropTypes.func.isRequired,
    onSelectChanges: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    canEdit: PropTypes.bool,
    formDatas: PropTypes.shape({}).isRequired,
  }

  static defaultProps = {
    submitting: false,
    canEdit: false,
  }

  render() {
    const {
      submitting,
      canEdit,
      handleSubmit,
      onChanges,
      onTextChanges,
      onSelectChanges,
      onBack,
      formDatas,
    } = this.props;

    const {
      tipoClase = [], tipoModalidad = [], metodologias = [], tipoContenido = [],
      profesoresMateria = [],
    } = formDatas;

    const listProfesores = profesoresMateria.map(({ parentId, label }) => ({
      value: parentId,
      label,
    }));

    return (
      <Card>
        <CardBody style={{ padding: '0' }}>
          <Form className="form" onSubmit={handleSubmit}>
            <Col lg={4} md={6} lx={12}>
              <div className="form__form-group">
                <span className="form__form-group-label required">Profesor:</span>
                <div className="form__form-group-field">
                  <Field
                    key="profesorContenido"
                    name="profesorContenido"
                    placeholder="Profesor"
                    onChange={onSelectChanges}
                    options={listProfesores}
                    component={renderSelectField}
                    isDisabled={!canEdit}
                  />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6} lx={12}>
              <div className="form__form-group">
                <span className="form__form-group-label required">Tipo Clase</span>
                <div className="form__form-group-field">
                  <Field
                    name="tipoClase"
                    component={renderSelectField}
                    placeholder="Tipo Clase"
                    autoComplete="false"
                    options={tipoClase}
                    isDisabled={!canEdit}
                    onChange={onSelectChanges}
                  />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6} lx={12}>
              <div className="form__form-group">
                <span className="form__form-group-label required">Fecha</span>
                <div className="form__form-group-field">
                  <Field
                    name="fecha"
                    component={TextBox}
                    type={canEdit ? 'date' : 'text'}
                    // format={value => this.format(canEdit, value)}
                    placeholder="Fecha"
                    autoComplete="false"
                    onBlur={({ target }) => onTextChanges(target)}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6} lx={12}>
              <div className="form__form-group">
                <span className="form__form-group-label required">Modalidad</span>
                <div className="form__form-group-field">
                  <Field
                    name="modalidad"
                    component={renderSelectField}
                    placeholder="Modalidad"
                    autoComplete="false"
                    options={tipoModalidad}
                    isDisabled={!canEdit}
                    onChange={onSelectChanges}
                  />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6} lx={12}>
              <div className="form__form-group">
                <span className="form__form-group-label required">Tipos de Contenido</span>
                <div className="form__form-group-field">
                  <Field
                    name="tiposContenidos"
                    component={renderSelectField}
                    placeholder="Tipos Contenidos"
                    autoComplete="false"
                    options={tipoContenido}
                    isDisabled={!canEdit}
                    isMulti={!false}
                    onChange={onSelectChanges}
                    addDefaultOption={false}
                  />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6} lx={12}>
              <div className="form__form-group">
                <span className="form__form-group-label required">Unidad</span>
                <div className="form__form-group-field">
                  <Field
                    name="unidad"
                    component={TextBox}
                    maxLength="128"
                    placeholder="Unidad"
                    autoComplete="false"
                    disabled={!canEdit}
                    onBlur={({ target }) => onTextChanges(target)}
                  />
                </div>
              </div>
            </Col>
            <Col md={12}>
              <div className="form__form-group">
                <span className="form__form-group-label required">Contenidos</span>
                <div className="form__form-group-field">
                  <Field
                    name="contenidos"
                    placeholder="Contenidos"
                    type="textarea"
                    maxLength="2048"
                    component={TextBox}
                    autoComplete="false"
                    disabled={!canEdit}
                    onBlur={({ target }) => onTextChanges(target)}
                  />
                </div>
              </div>
            </Col>
            <Col md={12}>
              <div className="form__form-group">
                <span className="form__form-group-label required">Metodologías Empleadas</span>
                <Field name="metodologias" component={renderErrorField} />
                <div className="form__form-group-field">
                  <div className="summary-container container" style={{ paddingTop: '0' }}>
                    <Row>
                      {metodologias.map(metodologia => (
                        <Col md={6} xl={4} sm={12} key={`col_metodologia_${metodologia.value}`}>
                          <Field
                            name={`metodologia_${metodologia.value}`}
                            key={`metodologia_${metodologia.value}`}
                            component={renderCheckBoxField}
                            label={
                              metodologia.requiereTexto && metodologia.selected ? (
                                <div className="form__form-group">
                                  <span className="form__form-group-label required">{metodologia.label}</span>
                                  <div className="form__form-group-field">
                                    <Field
                                      name={`metodologia_otro_${metodologia.value}`}
                                      key={`metodologia_otro_${metodologia.value}`}
                                      component={TextBox}
                                      type="textarea"
                                      maxLength="128"
                                      placeholder="Otro"
                                      autoComplete="false"
                                      disabled={!canEdit}
                                      onBlur={({ target }) => onTextChanges({
                                        ...target, metodologiaValue: metodologia.value,
                                      })}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <span>{metodologia.label}</span>
                              )
                            }
                            className={metodologia.selected ? 'checked' : ''}
                            value={metodologia.selected}
                            defaultChecked={metodologia.selected}
                            disabled={!canEdit}
                            onChange={(evt) => {
                              if (!evt.currentTarget || !canEdit) {
                                return false;
                              }

                              onChanges({
                                value: metodologia.value,
                                selected: evt.target.checked,
                              });

                              return false;
                            }}
                          />
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Form>
          <div className="card-body" style={{ padding: '0 20px', height: '1.2rem' }}>
            {canEdit ? (
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
            ) : null
            }
            <button
              type="submit"
              className="btn btn-outline-secondary"
              onClick={onBack}
            >Cancelar - Volver
            </button>
          </div>
        </CardBody>
      </Card>
    );
  }
}

const ContentRecordReduxForm = reduxForm({
  form: 'ContentRecordReduxForm',
  validate: validateForm,
  enableReinitialize: true,
})(ContentRecordForm);

export default setPropsAsInitialValues(ContentRecordReduxForm);
